<button type="button" class="btn btn-sm btn-light btn-light-walai border rounded-pill text-dark px-3 shadow-none"
  data-bs-toggle="modal" data-bs-target="#exportModalLong">
  <i class="bi bi-download me-1"></i> {{ 'Export' | translate }}
</button>

<!-- Modal -->
<div class="modal fade" id="exportModalLong" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title fw-bold text-dark" id="exampleModalLongTitle">
          <i class="bi bi-download me-2 text-primary"></i>{{ 'ExportCitation' | translate }}
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">

        <!-- Navigation Pills -->
        <ul class="nav nav-pills justify-content-center gap-2 mb-3">
          <li class="nav-item">
            <a class="nav-link" [class.active-export]="type === 'MARC'" (click)="export('MARC')">MARC</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" [class.active-export]="type === 'MARCISO2709'" (click)="export('MARCISO2709')">ISO
              2709</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" [class.active-export]="type === 'Bibliography'" (click)="export('Bibliography')">{{
              'Bibliography' | translate }}</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" [class.active-export]="type === 'ENDNOTE'" (click)="export('ENDNOTE')">EndNote</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" [class.active-export]="type === 'DublinCore'" (click)="export('DublinCore')">{{
              'DublinCore' | translate }}</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" [class.active-export]="type === 'APAStyle'" (click)="export('APAStyle')">{{ 'APAStyle' |
              translate }}</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" [class.active-export]="type === 'RISForZotero'" (click)="export('RISForZotero')">RIS
              (Zotero)</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" [class.active-export]="type === 'RISForMendeley'" (click)="export('RISForMendeley')">RIS
              (Mendeley)</a>
          </li>
        </ul>

        <ngx-spinner bdOpacity="0.3" bdColor="" size="default" color="#581f87" type="ball-pulse-sync"
          [fullScreen]="false">
        </ngx-spinner>

        <!-- Content Area -->
        <div>
          <div class="card border-0 bg-light">
            <div class="card-body shadow-inner">

              <!-- Text Content -->
              <div *ngIf="type !== 'MARC'">
                <div *ngFor="let item of data" [innerHTML]="item.data" class="mb-2"></div>
              </div>

              <!-- MARC Table -->
              <div *ngIf="type == 'MARC'" class="table-responsive rounded-3 border bg-white">
                <table class="table table-hover mb-0">
                  <thead class="bg-light">
                    <tr>
                      <th scope="col" class="py-3 ps-3 text-secondary">{{ 'Tag' | translate }}</th>
                      <th scope="col" class="py-3 text-center text-secondary">{{ 'Ind1' | translate }}</th>
                      <th scope="col" class="py-3 text-center text-secondary">{{ 'Ind2' | translate }}</th>
                      <th scope="col" class="py-3 text-secondary">{{ 'SubfieldData' | translate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let tag of marc">
                      <th scope="row" class="ps-3 text-primary font-monospace">{{ tag.TagID }}</th>
                      <td class="text-center font-monospace text-muted">{{ tag.Indicator1 }}</td>
                      <td class="text-center font-monospace text-muted">{{ tag.Indicator2 }}</td>
                      <td>
                        <div [innerHTML]="tag.Subfield" class="text-break"></div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer bg-light">
        <button type="button" class="btn btn-light border" data-bs-dismiss="modal">{{ 'Close' | translate }}</button>
        <button type="button" class="btn btn-primary" (click)="saveAsTextFile()">
          <i class="bi bi-save me-1"></i> {{ 'SaveToFile' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>